<template lang="pug">
  .box
    Loader(v-if='loading')
    Order(
      :document='documentUrl'
      v-else
    )
    ErrorModal(
      v-if='hasError'
      :error='error'
      :retry='retry'
    )
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Order from "@/components/Order.vue";
import ErrorModal from "@/components/ErrorModal.vue";

export default {
  data: () => ({
    document: null,
    loading: true,
    hasError: false,
    error: {
      name: "Неизвестная ошибка",
      message: "Произошла неизвестная ошибка"
    }
  }),
  computed: {
    ...mapGetters({
      formData: "form/data",
      serviceId: "services/current",
      submit: "submit/submit"
    }),
    documentUrl() {
      return this.submit && this.submit.data.document_url
        ? this.submit.data.document_url
        : "";
    }
  },
  components: {
    Order,
    ErrorModal
  },
  methods: {
    ...mapMutations("document", ["setId", "setPaymentPath", "setQrcodePath"])
    // loadDocument() {
    //   let data = {
    //     data: this.formData,
    //     productId: this.serviceId
    //   };
    //
    //   return api.kiosk(data);
    // },
    // async retry() {
    //   this.hasError = false;
    //   try {
    //     let res = await this.loadDocument();
    //     console.log(res);
    //     this.document = res.data.document;
    //     this.setId(res.data.document.split("/")[4]);
    //     this.setPaymentPath(res.data.payment);
    //     this.setQrcodePath(res.data.qrcode);
    //     this.loading = false;
    //   } catch (error) {
    //     console.log(error);
    //     this.error = error;
    //     this.hasError = true;
    //     this.loading = false;
    //   }
    // }
  },
  async mounted() {
    this.loading = false;
    // try {
    //   let res = await this.loadDocument();
    //   console.log(res);
    //   this.document = res.data.document;
    //   this.setId(res.data.document.split("/")[4]);
    //   this.setPaymentPath(res.data.payment);
    //   this.setQrcodePath(res.data.qrcode);
    //   this.loading = false;
    // } catch (error) {
    //   console.log(error.message);
    //   this.error = error;
    //   this.hasError = true;
    //   this.loading = false;
    // }
  }
};
</script>
